import { useEffect, useContext, useCallback } from 'react';

import { readNotifications } from 'actions/notifications';

import { IdleContext } from 'context/IdleContext';

const NotificationsReader = ({ notifications, enabled = true }) => {
    const idleCtx = useContext(IdleContext);

    const attemptRead = useCallback(() => {
        if (!notifications?.length) {
            return;
        }

        if (idleCtx?.isIdle) {
            return;
        }

        if (!enabled) {
            return;
        }

        readNotifications(notifications);
    }, [notifications, idleCtx?.isIdle, enabled]);

    useEffect(() => {
        attemptRead();
    }, [attemptRead]);

    return null;
}

export default NotificationsReader;
